import axios from "axios";
const LoginUser = async (uri, data) => {
  const { email, password } = data;
  try {
    const { data } = await axios.get(`${uri}`);
    if (data) {
      for (const key in data) {
        if (
          data[key].emailAddress === email &&
          data[key].password === password
        ) {
          return {
            dataExist: "valid",
            data: {
              lastName: data[key].lastName,
              firstName: data[key].firstName,
              emailAddress:
                data[key].emailAddress,
            },
          };
        }
      }
      return {
        dataExist: "invalid",
        errorName: "Invalid Details",
      };
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export default LoginUser;
